// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"11b7a2ec","455":"41261023","977":"542e9b08"}[chunkId] + ".chunk.js";
};